module.exports = __webpack_public_path__ + "media/images/menu/channel_1_on-b11be04ecf7513c2f8a24ab9f4fb9de3.jpg";